export function initScrollNavbar() {
    let lastScrollTop = 0;
    const navbar = document.querySelector('.navbar');
    const scrollThreshold = 120; // Mindesthöhe für Scroll-Effekt
    
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        // Zeige Navbar beim Scrollen nach oben
        if (currentScroll > scrollThreshold) {
            if (currentScroll < lastScrollTop) {
                // Scrolling nach oben
                navbar.classList.add('navbar--visible');
                navbar.classList.remove('navbar--hidden');
            } else {
                // Scrolling nach unten
                navbar.classList.add('navbar--hidden');
                navbar.classList.remove('navbar--visible');
            }
        } else {
            // Am Seitenanfang
            navbar.classList.remove('navbar--visible', 'navbar--hidden');
        }
        
        lastScrollTop = currentScroll;
    });
} 